import { render } from "./NewPriceGroupView.vue?vue&type=template&id=acd68e6a"
import script from "./NewPriceGroupView.vue?vue&type=script&lang=js"
export * from "./NewPriceGroupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__